import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { KModal, KTextInput } from "@kyburz/kdesign-system";
import useSetState from "../../hooks/useSetState";
import EmptyLayout from "../../components/layouts/EmptyLayout";
import { login, isAuthenticated } from "../../apiCalls/auth";
import { setUser, setAlert, clearUser } from "../../redux/actions/actions";
import { DEFAULT_ROUTE } from "../../components/navigation/Navigation";

const Login = () => {
  const [{ username, password, region, errors }, setState] = useSetState({
    username: "",
    password: "",
    region: "main",
    errors: {
      username: null,
      password: null,
      region: null,
    },
  });

  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (region !== "main" && region !== "edv") {
        setState({
          errors: { username: null, password: null, region: "Invalid region" },
        });
        return;
      }
      const res = await login({ username, password });
      if (res.token) {
        document.cookie = `token=${res.token};path=/;`;
        localStorage.setItem("refresh_token", res?.refresh_token);
        localStorage.setItem("region", region);
        const resAuth = await isAuthenticated();
        if (resAuth?.user) {
          if (resAuth.user?.is_admin) {
            dispatch(setUser(resAuth.user));
            history.push(DEFAULT_ROUTE);
          } else {
            document.cookie =
              "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            localStorage.removeItem("region");
            localStorage.removeItem("refresh_token");
            dispatch(clearUser());
            dispatch(
              setAlert(
                "You have no admin permissions to perform this action.",
                "error",
              ),
            );
            setState({
              username: "",
              password: "",
              region: "main",
              errors: { username: null, password: null },
            });
          }
        }
      } else {
        setState({ errors: { ...res.errors, region: null } });
      }
    } catch (err) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("region");
      setState({
        username: "",
        password: "",
        region: "main",
        errors: { username: null, password: null },
      });
      console.error(err);
    }
  };

  const handleChange = (e) =>
    setState({
      [e.target.name]: e.target.value,
      errors: { username: null, password: null },
    });

  return (
    <EmptyLayout>
      <KModal
        title="Login to KYBURZ Admin Portal"
        size="regular"
        primaryCTAColor="primary"
        primaryCTAText="LOGIN"
        primaryCTAonClick={handleSubmit}
      >
        <form noValidate>
          <KTextInput
            value={region}
            label="Region"
            name="region"
            placeholder="edv | main"
            width="452px"
            onChange={handleChange}
            error={errors.region != null}
            errorText={errors.region}
          />
          <KTextInput
            value={username}
            label="Email*"
            name="username"
            placeholder="john@smith.com"
            type="email"
            error={errors.username != null}
            errorText={errors.username}
            onChange={handleChange}
            width="452px"
          />
          <KTextInput
            value={password}
            label="Password*"
            name="password"
            type="password"
            error={errors.password != null}
            errorText={errors.password}
            onChange={handleChange}
            width="452px"
          />
        </form>
      </KModal>
    </EmptyLayout>
  );
};

export default Login;
